import React from 'react';
import { FaTwitter, FaGithub, FaLinkedin } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';
import {
    AboutDiv,
    Column,
    Img,
    AboutInfo,
    AboutInfoP,
    HeaderUl,
    HeaderLi,
    JelloHori,
} from './Styles';

import { Container, H1 } from '../../SharedStyles/SharedStyles';
const socialMediaLinks = [
    {
        id: 0,
        link: 'https://www.linkedin.com/in/tarun-kumar-bhardwaj-70374b262/',
        icon: <FaLinkedin />,
    },
    {
        id: 1,
        link: 'https://github.com/itarun1',
        icon: <FaGithub />,
    },
    // {
    //     id: 2,
    //     link: '#',
    //     icon: <FaTwitter />,
    // },
    // /* {
    //     id: 3,
    //     link: 'https://leetcode.com/aadityaneve',
    //     icon: <SiLeetcode />,
    // }, */
];
const About = () => {
    return (
        <Container className='about'>
            <AboutDiv>
                <Column>
                    <Img src='https://avatars.githubusercontent.com/u/95850621?v=4' alt='my image' />
                </Column>
                <Column>
                    <H1>About Me</H1>
                    <AboutInfo>
                        <AboutInfoP>
                        Hello, I'm Tarun Kuamr Bhardwaj, a JavaScript Full Stack Engineer
                        with a passion for creating efficient and scalable web applications.
                        I have expertise in front-end frameworks like React and Angular,
                        and back-end frameworks like Node.js and Express.js.
                        I have experience in designing RESTful APIs, implementing microservices architecture,
                        and using Git for version control. In my free time, I enjoy exploring 
                        new technologies and contributing to open-source projects. I'm excited
                        to continue growing as a developer and to make a positive impact in the tech industry.
                        </AboutInfoP>
                       
                    </AboutInfo>
                    <HeaderUl>
                        {socialMediaLinks.map((item) => (
                            <JelloHori key={item.id}>
                                <a
                                    href={item.link}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    <HeaderLi>{item.icon}</HeaderLi>
                                </a>
                            </JelloHori>
                        ))}
                    </HeaderUl>
                </Column>
            </AboutDiv>
        </Container>
    );
};

export default About;
